import React, { useEffect } from "react";
import { psychology, blissfuldays } from "../assets";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faEnvelope,
  faLocationDot,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";

const Footer = () => {
  const getCurrentYear = () => {
    return new Date().getFullYear();
  };

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://member.psychologytoday.com/verified-seal.js";
    script.type = "text/javascript";
    script.setAttribute("data-badge", "13");
    script.setAttribute("data-id", "1231924");
    script.setAttribute(
      "data-code",
      "aHR0cHM6Ly93d3cucHN5Y2hvbG9neXRvZGF5LmNvbS9hcGkvdmVyaWZpZWQtc2VhbC9zZWFscy9bQkFER0VdL3Byb2ZpbGUvW1BST0ZJTEVfSURdP2NhbGxiYWNrPXN4Y2FsbGJhY2s="
    );
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const quickLinks = [
    { name: "Home", path: "/" },
    { name: "About Us", path: "/aboutme" },
    { name: "Services", path: "/mainservicepage" },
    { name: "FAQ", path: "/faq" },
    { name: "Contact", path: "/contact" },
  ];

  const services = [
    { name: "Depression Treatment", path: "/depression" },
    { name: "Anxiety Management", path: "/anxiety" },
    { name: "ADHD Support", path: "/adhd" },
    { name: "Bipolar Disorder", path: "/bipolardisorder" },
  ];

  return (
    <footer className="bg-gradient-to-br from-neutral-900 via-neutral-900 to-neutral-800">
      <div className="max-w-7xl mx-auto px-6 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-12">
          <div className="lg:col-span-1">
            <div className="mb-6">
              <img
                src={blissfuldays}
                alt="Blissful Days"
                className="h-12 w-auto mb-4 rounded-lg"
              />
              <h3 className="text-heading-sm text-white mb-3">
                Blissful Days Psychiatric Services
              </h3>
              <p className="text-body-md text-neutral-400 leading-relaxed">
                Compassionate telehealth mental healthcare for Maryland, DC, and Virginia.
              </p>
            </div>
            <a
              href="https://www.psychologytoday.com/profile/1231924"
              className="sx-verified-seal inline-block"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="group transition-transform hover:scale-105">
                <img
                  src={psychology}
                  alt="Verified by Psychology Today"
                  className="max-w-[160px] h-auto rounded-lg"
                />
              </div>
            </a>
          </div>

          <div>
            <h4 className="text-heading-sm text-white mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.path}
                    className="text-body-md text-neutral-400 hover:text-primary-400 transition-colors duration-300 flex items-center gap-2 group"
                  >
                    <FontAwesomeIcon
                      icon={faArrowRight}
                      className="text-xs opacity-0 group-hover:opacity-100 transition-opacity"
                    />
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-heading-sm text-white mb-6">Our Services</h4>
            <ul className="space-y-3">
              {services.map((service, index) => (
                <li key={index}>
                  <Link
                    to={service.path}
                    className="text-body-md text-neutral-400 hover:text-primary-400 transition-colors duration-300 flex items-center gap-2 group"
                  >
                    <FontAwesomeIcon
                      icon={faArrowRight}
                      className="text-xs opacity-0 group-hover:opacity-100 transition-opacity"
                    />
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-heading-sm text-white mb-6">Contact Info</h4>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 w-10 h-10 bg-primary-500/10 rounded-lg flex items-center justify-center">
                  <FontAwesomeIcon
                    icon={faPhone}
                    className="text-primary-400"
                  />
                </div>
                <div>
                  <p className="text-body-sm text-neutral-500 mb-1">Phone</p>
                  <a
                    href="tel:2406103766"
                    className="text-body-md text-neutral-300 hover:text-primary-400 transition-colors"
                  >
                    (240) 610-3766
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 w-10 h-10 bg-primary-500/10 rounded-lg flex items-center justify-center">
                  <FontAwesomeIcon
                    icon={faEnvelope}
                    className="text-primary-400"
                  />
                </div>
                <div>
                  <p className="text-body-sm text-neutral-500 mb-1">Email</p>
                  <a
                    href="mailto:info@blissfuldayspsych.com"
                    className="text-body-md text-neutral-300 hover:text-primary-400 transition-colors break-all"
                  >
                    info@blissfuldayspsych.com
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 w-10 h-10 bg-primary-500/10 rounded-lg flex items-center justify-center">
                  <FontAwesomeIcon
                    icon={faLocationDot}
                    className="text-primary-400"
                  />
                </div>
                <div>
                  <p className="text-body-sm text-neutral-500 mb-1">Location</p>
                  <p className="text-body-md text-neutral-300">
                    Bowie, MD 20720
                    <br />
                    <span className="text-body-sm text-neutral-500">
                      (Telehealth Services)
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-neutral-800 pt-8">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-center md:text-left">
            <p className="text-body-md text-neutral-400">
              © {getCurrentYear()} Blissful Days Psychiatric Services. All Rights Reserved.
            </p>
            <p className="text-body-sm text-neutral-500">
              Providing compassionate mental health care across MD, DC & VA
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
